(ns practitest.frontend.integration-settings.auto-sync-tabs
  (:require [re-frame.core :as re-frame]
            [practitest.frontend.init :as init]
            [practitest.frontend.common.utils :as utils]
            [practitest.frontend.integration-settings.sub-tabs :as sub-tabs]))

;; Only renders the header/tab strip - the rest of the Auto-sync page is plain ERB (PT1-8130).
(def db-key :auto-sync-tabs)

(re-frame/reg-event-db
  ::initialize-db
  (fn [db [_ config]]
    (assoc db db-key
           {:tabs             (:tabs config [])
            :active-tab       (:active-tab config "")
            :bugtracker-label (:bugtracker-label config "")
            :identifier       (:identifier config "")})))

(re-frame/reg-sub
  ::state
  (fn [db _]
    (get db db-key)))

(defn auto-sync-tabs-root [_]
  (let [{:keys [tabs active-tab bugtracker-label identifier]} @(re-frame/subscribe [::state])]
    [sub-tabs/sub-tabs {:active active-tab :tabs tabs
                         :bugtracker-label bugtracker-label :identifier identifier
                         :extra-offset? true}]))

(defn ^:dev/after-load remount []
  (init/remount-roots "integration-settings-auto-sync-tabs-component"
                      auto-sync-tabs-root))

(defn ^:export init [webcomponent options]
  (init/init! {:options       options
               :init-event-fn (fn [config] [::initialize-db config])
               :webcomponent  webcomponent
               :root-view     auto-sync-tabs-root}))

(utils/register-webcomponent! "integration-settings-auto-sync-tabs-component")
